import { convertDateToRenewDateTime } from "../../subscription-contract/utils/convertDateToRenewDateTime.js";
export function getRenewAtWithPause(baseRenewAt, pauseStart, pauseStop, now = new Date()) {
    const base = baseRenewAt ? convertDateToRenewDateTime(baseRenewAt) : "";
    const isBlankOrNull = (v) => !v || v.trim() === "" || v.trim().toLowerCase() === "null";
    // If there is no valid pause start or pause stop then return the base renew date
    if (isBlankOrNull(pauseStart) || isBlankOrNull(pauseStop)) {
        return base;
    }
    let startIso;
    let stopIso;
    try {
        startIso = convertDateToRenewDateTime(pauseStart.trim());
        stopIso = convertDateToRenewDateTime(pauseStop.trim());
    }
    catch {
        // If the pause dates cannot be converted then return the base renew date
        return base;
    }
    const start = new Date(startIso);
    const stop = new Date(stopIso);
    // If the pause dates are invalid then return the base renew date
    if (Number.isNaN(start.getTime()) || Number.isNaN(stop.getTime())) {
        return base;
    }
    const nowTime = now.getTime();
    const startPastOrNow = start.getTime() <= nowTime;
    const stopInFuture = nowTime < stop.getTime();
    // If we are currently inside the pause window
    if (startPastOrNow && stopInFuture) {
        // If there is no valid base renew date then use the pause stop date
        if (!base) {
            return stopIso;
        }
        const baseDate = new Date(base);
        // If the base renew date is invalid then use the pause stop date
        if (Number.isNaN(baseDate.getTime())) {
            return stopIso;
        }
        // If the base renew date is on or before the pause stop date then use the pause stop date
        if (baseDate.getTime() <= stop.getTime()) {
            return stopIso;
        }
        // If the base renew date is after the pause stop date then keep the base renew date
        return base;
    }
    // If we are not inside the pause window then return the base renew date
    return base;
}
